module.exports = __webpack_public_path__ + "img/58.af950061.jpg";